import useLocale from '@/hooks/useLocale';
import React, { useCallback, useEffect, useState } from 'react';
import { SearchDomain } from './components/SearchDomain';
import { IconArrow, IconButton } from 'gatorcomponents';
import { domainsActions } from '@/redux/modules';
import { useDispatch, useSelector } from 'react-redux';
import HgLogoV2 from '@/media/logo/HgLogoV2';
import * as Styles from './BuyDomainHandler.styles';
import { useHistory } from 'react-router';

const BuyDomainHandler = () => {
  const [domain, setDomain] = useState('');
  const [searchedDomain, setSearchedDomain] = useState('');
  const [checkedItems, setCheckedItems] = useState([]);
  const { buyDomain: buyDomainLocale, routes: routesLocale } = useLocale();

  const { buyDomain } = useSelector(state => state.newDomains);

  const dispatch = useDispatch();
  const history = useHistory();


  const getSearchProps = useCallback(() => {
    const buttonsProps = {
      rightButton: {
        label: buyDomainLocale.continueButtonLabel,
        iconRight: <IconArrow direction="right" />,
      },
    };

    const redirectToInvoice = (invoiceId) => {
      history.push(`${routesLocale.invoices}${routesLocale.unpaid}/${invoiceId}?openInvoice=true`);
    };

    const searchDomain = ({ domain }) => {
      setCheckedItems([]);
      setSearchedDomain(domain);
      const domainParts = domain.replace(/^www\./, '').split('.');
      const sld = domainParts[0];
      const tld = domainParts.slice(1).join('.');
      dispatch(domainsActions.buyDomain.search.request({ tld, sld }));
    };

    const handleBuyDomain = () => {
      const protectIdCycle = (cycle) => {
        const rules = {
          one: 'annually',
          two: 'biennially',
          three: 'triennially',
        };

        return rules[cycle] || 'annually';
      };


      const hasDotCom = checkedItems.some(item => item.tld === '.com');
      const hasDotComBr = checkedItems.some(item => item.tld === '.com.br');

      const getRelated = () => {
        if (hasDotCom) {
          return '.com';
        }

        if (hasDotComBr) {
          return '.com.br';
        }
      };

      const domains = checkedItems.map((item) => {
        const newDomainObject = {};

        newDomainObject.domainCycle = item.cycle;
        newDomainObject.related = [];
        if (item.protectId) {
          newDomainObject.related.push({
            id: 'p',
            type: 'addon',
            cycle: protectIdCycle(item.cycle),
          });
        }
        newDomainObject.sld = item.sld;
        newDomainObject.tld = item.tld;
        newDomainObject.type = 'register';
        newDomainObject.domainCycle = item.cycle;

        if (item.radix) {
          newDomainObject.domainRelated = getRelated();
        }

        return newDomainObject;
      });


      dispatch(domainsActions.buyDomain.requestBuyDomain({ domains, redirectToInvoice }));
    };

    return {
      searchLocales: buyDomainLocale.search,
      listLocales: buyDomainLocale.list,
      buttonsProps,
      domainsList: buyDomain.search.result.domains || [],
      freeDomains: buyDomain.search.result.domainsFree || [],
      searchDomain,
      searchLoading: buyDomain.search.loading,
      result: buyDomain.search.result,
      checkedItems,
      setCheckedItems,
      handleBuyDomain,
      loading: buyDomain.loading,
      domain,
      searchedDomain,
      setDomain,
    };
  }, [
    routesLocale,
    buyDomainLocale,
    dispatch,
    checkedItems,
    setCheckedItems,
    history,
    buyDomain,
    domain,
    searchedDomain,
    setDomain,
  ]);

  const onUnmount = useCallback(() => {
    dispatch(domainsActions.buyDomain.search.success({ result: [] }));
  }, [
    dispatch,
  ]);

  useEffect(() => () => onUnmount(), [onUnmount]);

  return (
    <Styles.BuyDomainHandlerWrapper>
      <Styles.LogoRow>
        <HgLogoV2 newMenu />

        <IconButton
          icon="IconClose"
          onClick={() => history.push(routesLocale.home)}
        />
      </Styles.LogoRow>

      <Styles.Container>
        <SearchDomain {...getSearchProps()} />
      </Styles.Container>
    </Styles.BuyDomainHandlerWrapper>
  );
};

export default BuyDomainHandler;
